import React from 'react';
import { aboutData } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { Target, Eye, Award, Users } from 'lucide-react';

export const About = () => {
  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto space-y-6">
            <h1 className="text-5xl font-bold text-gray-900">About Reverential Consultants</h1>
            <p className="text-xl text-gray-600">
              Your trusted partner in cloud innovation and digital transformation
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <Card className="border-0 shadow-lg">
              <CardContent className="p-8 space-y-4">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Target className="w-8 h-8 text-blue-700" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Our Mission</h2>
                <p className="text-gray-600 leading-relaxed">{aboutData.mission}</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg">
              <CardContent className="p-8 space-y-4">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Eye className="w-8 h-8 text-blue-700" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Our Vision</h2>
                <p className="text-gray-600 leading-relaxed">{aboutData.vision}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {aboutData.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-blue-700 mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
            <p className="text-xl text-gray-600">The principles that guide everything we do</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {aboutData.values.map((value, index) => {
              const icons = [Award, Users, Target, Eye];
              const Icon = icons[index];
              return (
                <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow">
                  <CardContent className="p-6 space-y-4 text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                      <Icon className="w-8 h-8 text-blue-700" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{value.title}</h3>
                    <p className="text-gray-600">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Team Image */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-4xl font-bold text-gray-900">Expert Team, Global Reach</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our team of certified cloud architects, DevOps engineers, and infrastructure specialists brings decades of combined experience in delivering enterprise-grade solutions.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                With operations spanning 45+ countries and 15+ data centers worldwide, we provide local expertise with global capabilities.
              </p>
            </div>
            <div>
              <img
                src={aboutData.image}
                alt="Our Team"
                className="rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;